module.exports = __webpack_public_path__ + "img/kj2.9d38ff7c.png";